import { axiosInstance, axiosInstanceExporters } from "./";

const categoriesLookup = async () =>
  await axiosInstance.get("/api/Category/Get");

const subCategoriesLookup = async (params) =>
  await axiosInstance.get("/api/SubCategory/Get", {
    params,
    paramsSerializer: { indexes: null }
  });

const countriesLookup = async (params) =>
  await axiosInstance.get("/api/Country/Get", { params });

const exportersLookup = async (params) =>
  await axiosInstance.get("/api/User/GetExporterNames", { params });

const companiesLookup = async (params) =>
  await axiosInstance.get("/api/Company/GetCompanyNames", { params });

const businessVerificationTypesLookup = async (params) =>
  await axiosInstance.get(
    "/api/CompanyBusinessVerificationRequest/GetBusinessVerificationTypes",
    { params }
  );

const businessTypesLookup = async (params) =>
  await axiosInstance.get(
    "/api/CompanyBusinessVerificationRequest/GetBusinessTypes",
    { params }
  );

const businessVerificationStatusLookup = async (params) =>
  await axiosInstance.get(
    "/api/CompanyBusinessVerificationRequest/GetRequestStatus",
    { params }
  );

const voucherCompaniesLookup = async (params) =>
  await axiosInstanceExporters.get("/api/Company/GetCompanyNames", {
    params
  });

const transactionPaymentReasonsLookup = async (params) =>
  await axiosInstanceExporters.get(
    "api/Transaction/GetPaymentReason",
    {
      params
    }
  );

const transactionStatusLookup = async (params) =>
  await axiosInstanceExporters.get("api/Transaction/GetStatus", {
    params
  });

const rolesLookup = async () =>
  await axiosInstance.get("/api/Role/GetLookup");

const pricingPlanLookup = async () =>
  await axiosInstanceExporters.get(`/api/Subscription/Get`);

export {
  categoriesLookup,
  subCategoriesLookup,
  countriesLookup,
  exportersLookup,
  companiesLookup,
  businessVerificationTypesLookup,
  businessTypesLookup,
  businessVerificationStatusLookup,
  voucherCompaniesLookup,
  transactionPaymentReasonsLookup,
  transactionStatusLookup,
  rolesLookup,
  pricingPlanLookup
};
